<template>
  <section class="request-error" role="alert">
    <p class="request-error__operation">{{ $t(`requestErrors.operations.${error.operation}`) }}</p>
    <h2 class="h4">{{ $t(`requestErrors.${error.kind}.title`) }}</h2>
    <p v-if="!error.uncertain">{{ $t(`requestErrors.${error.kind}.message`) }}</p>
    <p v-if="error.uncertain">{{ $t("requestErrors.uncertain") }}</p>
    <p v-if="keepInputs">{{ $t("requestErrors.kept") }}</p>
    <p v-if="error.operation === 'newsletterCheck'">{{ $t("requestErrors.newsletterOptional") }}</p>
    <p class="request-error__reference">
      <strong>{{ $t("requestErrors.code") }}: {{ error.code }}</strong><br />
      {{ $t("requestErrors.time") }}: <time :datetime="error.occurredAt">{{ formattedTime }}</time>
    </p>
    <div class="request-error__actions">
      <button v-if="retry && error.retryable" type="button" class="btn btn-cta" @click="$emit('retry')">
        {{ $t("requestErrors.retry") }}
      </button>
      <a class="btn btn-outline-secondary" :href="supportLink">{{ $t("requestErrors.support") }}</a>
    </div>
    <details class="mt-3">
      <summary>{{ $t("requestErrors.details") }}</summary>
      <pre class="request-error__details mt-2">{{ diagnostics }}</pre>
    </details>
  </section>
</template>

<script>
export default {
  props: {
    error: { type: Object, required: true },
    retry: Boolean,
    keepInputs: Boolean,
  },
  computed: {
    formattedTime() {
      return new Date(this.error.occurredAt).toLocaleString(this.$i18n.locale === "en" ? "en-GB" : "de-DE", {
        timeZoneName: "short",
      });
    },
    diagnostics() {
      return [
        this.$t(`requestErrors.operations.${this.error.operation}`),
        `${this.$t("requestErrors.code")}: ${this.error.code}`,
        `${this.$t("requestErrors.time")}: ${this.error.occurredAt}`,
        `${this.$t("requestErrors.link")}: ${window.location.origin}${this.$route.fullPath}`,
      ].join("\n");
    },
    supportLink() {
      const subject = `${this.$t("requestErrors.supportSubject")} (${this.error.code})`;
      const body = `${this.$t("requestErrors.supportIntro")}\n\n${this.diagnostics}`;
      return `mailto:technik@gfu.net?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },
  },
};
</script>

<style scoped>
.request-error {
  margin: 1rem auto;
  padding: 1.5rem;
  max-width: 56rem;
  color: #042b60;
  background: #f8f8f8;
  border-left: 4px solid #fdc41f;
  border-radius: 5px;
  text-align: left;
}
.request-error__reference { font-size: 0.9rem; overflow-wrap: anywhere; }
.request-error__operation { font-size: 0.9rem; font-weight: 600; margin-bottom: 0.5rem; }
.request-error__actions { display: flex; flex-wrap: wrap; gap: 0.75rem; }
.request-error__actions .btn-outline-secondary { color: #033878; border-color: #033878; }
.request-error__actions .btn-outline-secondary:hover { background: #dceeeb; }
.request-error__actions .btn:focus-visible { outline: 3px solid #033878; outline-offset: 3px; }
.request-error__details { white-space: pre-wrap; overflow-wrap: anywhere; font-size: 0.8rem; }
summary { cursor: pointer; }
</style>
